import { DiscountCategories, DiscountCategoriesJSON } from '@general/js/enums/DiscountsAndLoadingsEnum';
import { isEmptyString } from '@general/js/utils/StringTransformUtils';

/**
 * Converts a string that is a percentage with multiple decimals to a percentage with a specified precision that is still a string.
 * Also works with floats.
 *
 * @param {string} percentage - the string percentage value, also works with floats
 * @param {number} precision - the number of decimal points
 *
 * @returns {string} - percentage with specified precision
 */
export const formatPercentageString = (percentageStr, precision = 0) => {
  if (!isEmptyString(percentageStr) && !Number.isNaN(parseFloat(percentageStr))) {
    const percentage = parseFloat(percentageStr);
    const roundedPercentage = percentage.toFixed(precision);
    return `${roundedPercentage.toString()}%`;
  }
  return '';
};

/**
 * This takes the JSON property names in the object for discounts and converts to the string it should be displayed as on the FE.
 *
 * @param {string} category - the JSON property name. E.g. adfDiscount
 * @returns {string} - The string to be displayed on the FE for discounts & loadings. E.g. ADF discount
 */
export const stringifyDiscountCategory = (category) => {
  switch (category) {
    case DiscountCategoriesJSON.REBATE_DISCOUNT:
      return DiscountCategories.REBATE;
    case DiscountCategoriesJSON.DVA_DISCOUNT:
      return DiscountCategories.DVA_DISCOUNT;
    case DiscountCategoriesJSON.LHC_SURCHARGE:
      return DiscountCategories.LHC_LOADING;
    case DiscountCategoriesJSON.ABD_DISCOUNT:
      return DiscountCategories.ABD_DISCOUNT;
    case DiscountCategoriesJSON.ADF_DISCOUNT:
      return DiscountCategories.ADF_DISCOUNT;
    case DiscountCategoriesJSON.RESERVIST_DISCOUNT:
      return DiscountCategories.RESERVIST_DISCOUNT;
    case DiscountCategoriesJSON.TRANSITION_DISCOUNT:
      return DiscountCategories.TRANSITION_DISCOUNT;
    case DiscountCategoriesJSON.VETERAN_DISCOUNT:
      return DiscountCategories.VETERAN_DISCOUNT;
    default:
      return '';
  }
};
